export default "__VITE_ASSET__DcyKd4sv__"